import React from 'react'
import { connect } from 'react-redux'
import BuserForm from './BuserForm'

import {
  clear_buser,
} from '../actions'

const mapStateToProps = state => {
  return {

  }
}
const mapDispatchToProps = dispatch => {
  return {
    clearBuser: () => dispatch( clear_buser() ),
  }
}

class ConnectedBuserEdit extends React.Component {
  componentWillMount() {
    this.props.clearBuser()
  }

  render(){
    const {buser_id} = this.props.match.params

    return <BuserForm actionName="update" buser_id={buser_id}/>
  }
}

const BuserEdit = connect(mapStateToProps, mapDispatchToProps)(ConnectedBuserEdit)
export default BuserEdit



// WEBPACK FOOTER //
// ./src/js/components/BuserEdit.js